import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { pinia } from './stores';
import './plugins/axios';
import './assets/styles/main.css';
import './styles/wellbeing.css';

// Benign chart resize noise — dev overlay and some browsers log this without breaking the app.
window.addEventListener('error', (event) => {
  if (/ResizeObserver loop/i.test(event.message || '')) {
    event.stopImmediatePropagation();
  }
});

createApp(App).use(router).use(pinia).mount('#app');
